import { red } from "@mui/material/colors";
import SuperEllipse from "react-superellipse";
import ResizeListener from "../../../utility/ResizeListener";
import "./dashboard.css";

const DashboardContainer = ({
  title,
  description,
  image,
  onClick,
  imageStyle,
}) => {
  const { width } = ResizeListener();
  return (
    <SuperEllipse
      r1={0.03}
      r2={0.2}
      style={{
        height: "250px",
        width: "28%",
        minWidth: width < 650 ? 370 : 300,
        backgroundImage: `linear-gradient(113.93deg, #3783FB -6.6%, #6CA5FF 111.66%)`,
        display: "flex",
        alignItems: "center",
        padding: "15px 30px",
        boxSizing: "border-box",
        position: "relative",
        cursor: "pointer",
        margin: "15px",
        overflow: "auto",
      }}
      onClick={onClick}
    >
      <img
        src={image}
        style={{
          position: "absolute",
          right: 25,
          top: 25,
          width: "45px",
          height: "45px",
          objectFit: "contain",
          ...imageStyle,
        }}
        alt={"Dashboard"}
      />

      <div>
        <div style={{ height: "120px" }}>
          <p
            style={{
              color: "white",
              fontSize: "22px",
              fontWeight: "600",
              margin: 0,
              marginBottom: "10px",
            }}
            className="roboto"
          >
            {title}
          </p>

          <span
            style={{
              color: "white",
              fontSize: "16px",
              margin: 0,
              textAlign: "left",
            }}
            className="roboto"
          >
            {description}
          </span>
        </div>
      </div>
    </SuperEllipse>
  );
};

export default DashboardContainer;
